exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-vue-modal {\n  background-color: white;\n  text-align: left;\n  border-radius: 0;\n  -webkit-box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n          box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n  padding: 0;\n}\n.v--modal-overlay {\n  background-color: rgba(0,0,0,0.6) !important ;\n}\n", ""]);

// exports
